import React from 'react';
import AlertContainer from '../containers/AlertContainer';

const DisplayView = () => (

      <AlertContainer />

);

export default DisplayView;
